export const WORKFLOW_STEPS = {
    INIT: 'INIT',
    SUBMIT: 'SUBMIT',
    REVIEW: 'REVIEW',
}